@import ../../../styles/helpers

.container
    color: black
    text-align: center
    h2
        +snappy
        font-size: 24px
        margin-bottom: $external_margin

.btnContainer
    display: flex
    gap: 20px